import { list, third, listItem, selected } from 'components/CameraModelSelector/style'
import { COLORS } from 'helpers/globals'

const star = {
  color: COLORS.gold,
  fontSize: '1.9rem',
  marginLeft: '.3rem'
}

export default {
  container: {
    ...third
  },
  expansionContainer: {
    ...third,
    width: '50%'
  },
  list: {
    ...list,
    borderLeft: `1px solid ${COLORS.quaternary}`
  },
  listItemOdd: {
    ...listItem,
    background: 'white !important'
  },
  listItemEven: {
    ...listItem,
    background: `${COLORS.tertiary} !important`
  },
  selected,
  modelName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1
  },
  warning: {
    ...star,
    color: COLORS.warning
  },
  star,
  clock: {
    ...star,
    color: COLORS.secondary,
    marginRight: '.2rem'
  },
  noMatch: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: '2rem',
    fontSize: '1.9rem',
    color: 'black'
  },
  line1: {
    marginBottom: '2rem',
    fontStyle: 'italic'
  },
  missingModelButton: {
    fontSize: '1.8rem',
    fontWeight: 400,
    color: 'white',
    background: COLORS.primary,
    padding: '.4rem .8rem',
    borderRadius: '.5rem',
    '&:hover': {
      color: 'white',
      background: COLORS.primaryHover
    }
  },
  break: {
    margin: '2rem 5% !important',
    width: '90%'
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ModelList/style.js